var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"mx-2",attrs:{"text":"","to":_vm.to,"elevation":"0"}},'v-btn',_vm.attrs,false),_vm.on),[_c('h5',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }